import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleColumnDialog } from '../../actions';
import TableConfigCell from './table-config-cell';

const mapDispatchToProps = (dispatch) => bindActionCreators({ toggleColumnDialog }, dispatch);

export default connect(null, mapDispatchToProps)(TableConfigCell);
